<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">تنظیمات کارکنان</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreateUser" variant="primary" class="d-flex align-items-center px-3">
                    <feather-icon size="17" icon="UserPlusIcon" class="mr-50" />
                    <span>ایجاد</span>
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-card v-if="usersList.length" class="p-0" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table responsive :items="usersList" :fields="fields" class="mb-0" striped>
                        <template #cell(isAccountActive)="data">
                            {{ data.item.isAccountActive ? 'فعال' : 'غیرفعال' }}
                        </template>
                        <template #cell(collaborationEndDate)="data">
                            {{
                                data.item.collaborationEndDate ?
                                    new Date(data.item.collaborationEndDate).toLocaleDateString('fa-IR') : '-'
                            }}
                        </template>
                        <template #cell(edit)="data">
                            <b-spinner v-if="loadingsButton[data.index]" variant="info" small></b-spinner>
                            <feather-icon v-else @click="showModalEdit(data.item, data.index)" size="20" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(delete)="data">
                            <feather-icon @click="showModalDelete(data.item)" size="20" icon="XCircleIcon"
                                class="pointer text-danger" color="#8d88a3" />
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
            <b-card v-else class="text-center pt-5 pb-4">
                موردی وجود ندارد
            </b-card>
            <b-pagination align="center" @input="getUsers" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create user ------------------------------->
        <b-modal id="management-user" :title="`${userMode} کاربر`" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <div class="px-1 py-50">
                <validation-observer ref="managementUserValidation">
                    <b-form @submit.prevent>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="نام" label-for="firstNameId" class="text-center">
                                    <validation-provider #default="{ errors }" name="نام" rules="required">
                                        <b-form-input autocomplete="off" dir="rtl" id="firstNameId"
                                            v-model="form.firstName" name="firstName"
                                            class="text-center user-select-none"
                                            :state="errors.length > 0 ? false : null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="نام خانوادگی" label-for="lastNameId" class="text-center">
                                    <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                                        <b-form-input autocomplete="off" dir="rtl" id="lastNameId"
                                            v-model="form.lastName" name="lastName" class="text-center user-select-none"
                                            :state="errors.length > 0 ? false : null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="وضعیت حساب" label-for="isAccountActiveId" class="text-center">
                                    <validation-provider #default="{ errors }" name="وضعیت حساب" rules="required">
                                        <v-select v-model="form.isAccountActive" :searchable="false" dir="rtl"
                                            :options="userStatus" id="isAccountActiveId"
                                            :class="{ 'border-danger': errors.length > 0 }"
                                            :reduce="(value) => value.id" style="border-radius: 6px;" label="name"
                                            :clearable="false">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="دسترسی به پرینتر" label-for="hasPrinterAccessId"
                                    class="text-center">
                                    <validation-provider #default="{ errors }" name="دسترسی به پرینتر" rules="required">
                                        <v-select v-model="form.hasPrinterAccess" :searchable="false" dir="rtl"
                                            :options="userStatus" id="hasPrinterAccessId"
                                            :class="{ 'border-danger': errors.length > 0 }"
                                            :reduce="(value) => value.id" style="border-radius: 6px;" label="name"
                                            :clearable="false">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <div>
                                    <b-form-group label="نام کاربری" label-for="usernameId" class="text-center">
                                        <validation-provider #default="{ errors }" name="نام کاربری"
                                            rules="required|userName">
                                            <b-form-input autocomplete="off" dir="ltr" id="usernameId"
                                                v-model="form.username" name="username"
                                                class="text-center user-select-none"
                                                :state="errors.length > 0 ? false : null" />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                    <div v-if="usernameDuplicate"
                                        class="d-flex align-items-center flex-column flex-md-row justify-content-center mb-2">
                                        <div class="mb-50 mb-md-0 mr-0 mr-md-50">
                                            پیشنهاد :
                                        </div>
                                        <b-badge @click="change" variant="light-primary" pill class="pointer">
                                            {{ `${form.username}-${storeId}` }}
                                        </b-badge>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="رمز عبور" label-for="passwordId" class="text-center">
                                    <validation-provider #default="{ errors }" name="رمز عبور"
                                        :rules="userMode == 'ایجاد' ? 'required' : null">
                                        <b-form-input autocomplete="off" dir="ltr" id="passwordId"
                                            v-model="form.password" name="password" class="text-center user-select-none"
                                            :state="errors.length > 0 ? false : null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <div>
                                    <b-form-group label="تاریخ پایان همکاری" label-for="dateId" class="text-center">
                                        <validation-provider #default="{ errors }" name="تاریخ پایان همکاری"
                                            rules="required">
                                            <b-form-input id="dateId" :state="errors.length > 0 ? false : null"
                                                autocomplete="off"
                                                class="text-center main-input font-weight-bolder pointer"
                                                :value="form.collaborationEndDate ? new Date(form.collaborationEndDate).toLocaleDateString('fa-IR') : null"
                                                name="dateId" />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                    <date-picker v-model="form.collaborationEndDate" :min="currentDate"
                                        format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD" custom-input="#dateId" />
                                </div>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                                    <b-form-input dir="rtl" v-model="form.description" name="description"
                                        autocomplete="off" class="text-center user-select-none" />
                                </b-form-group>
                            </b-col>
                            <b-col md="12">
                                <div class="my-1">
                                    <h5 class="text-center">دسترسی‌ها</h5>
                                    <div class="border-secondary rounded px-2 pt-2">
                                        <b-form-group label-for="rolesId" class="text-center">
                                            <v-select v-model="selectRole" :searchable="false" dir="rtl"
                                                :options="roles" :disabled="!!searchText" class="bg-white" id="rolesId"
                                                autocomplete="off" :reduce="(value) => value.id"
                                                style="border-radius: 6px;" label="name" :clearable="false">
                                                <template #no-options>
                                                    موردی وجود ندارد
                                                </template>
                                            </v-select>
                                        </b-form-group>
                                        <b-form-input v-model="searchText" placeholder="جستجو در دسترسی‌ها..." dir="rtl"
                                            class="my-2 user-select-none" name="searchText" />
                                        <div class="permissions-container border rounded px-1 px-md-2 pt-1 my-2">
                                            <div v-for="(item, index) in userPermissions" :key="index" class="mb-1">
                                                <b-form-checkbox v-model="form.permissions" :value="item.key">
                                                    {{ item.title }}
                                                </b-form-checkbox>
                                            </div>
                                        </div>
                                        <b-row class="mb-2">
                                            <b-col md="6">
                                                <b-button variant="outline-info" @click="selectAllDisplayed"
                                                    class="w-100">
                                                    انتخاب موارد نمایش داده شده
                                                </b-button>
                                            </b-col>
                                            <b-col md="6" class="mt-2 mt-md-0">
                                                <b-button variant="outline-danger" @click="clearAll" class="w-100">
                                                    بازنشانی همه دسترسی‌ها
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>

                        <b-button type="submit" variant="primary" @click="managementUser" :disabled="loadingButton"
                            class="w-100 mt-50 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ userMode }}</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <!------------------------------- modal delete user ------------------------------->
        <b-modal id="delete-user" title="حذف کاربر" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <div class="p-1">
                <h5 class="text-center text-danger mb-2">
                    آیا از حذف کاربر "{{ form.firstName + ' ' + form.lastName }}" مطمئن هستید؟
                </h5>
                <div class="d-flex align-items-center pt-1">
                    <b-button @click="$bvModal.hide('delete-user')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button @click="deleteUser" class="d-flex align-items-center justify-content-center w-50"
                        variant="danger" :disabled="loadingButton">
                        <span>بله</span>
                        <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                    </b-button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BFormTextarea, BForm, BFormRadio, BFormCheckbox, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, userName } from '@validations';
import vSelect from 'vue-select';
import { default as permissions } from '@/@core/data/permissions';

export default {
    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BBadge,
        BFormTextarea,
        BFormCheckbox
    },
    data() {
        return {
            required,
            userName,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            loadingsButton: [],
            isAdminIdentityVerified: false,
            usersList: [],
            fields: [
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'username',
                    label: 'نام کاربری',
                },
                {
                    key: 'isAccountActive',
                    label: 'وضعیت حساب',
                },
                {
                    key: 'collaborationEndDate',
                    label: 'تاریخ پایان همکاری',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
                {
                    key: 'delete',
                    label: 'حذف',
                },
            ],
            userStatus: [
                {
                    name: 'فعال',
                    id: true
                },
                {
                    name: 'غیرفعال',
                    id: false
                },
            ],
            currentDate: '',
            selectRole: null,
            roles: [
                {
                    name: 'نمایش همه',
                    id: null
                },
                {
                    name: 'مدیر داخلی',
                    id: 1
                },
                {
                    name: 'حسابدار',
                    id: 2
                },
                {
                    name: 'صندوق دار',
                    id: 3
                },
                {
                    name: 'سالن‌دار',
                    id: 4
                },
                {
                    name: 'سرآشپز',
                    id: 5
                },
                {
                    name: 'مدیر باشگاه مشتریان',
                    id: 6
                },
                {
                    name: 'مدیر انبار',
                    id: 7
                },
                {
                    name: 'انباردار',
                    id: 8
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null
            },
            storeId: null,
            form: {
                username: null,
                password: null,
                firstName: null,
                lastName: null,
                description: null,
                collaborationEndDate: null,
                isAccountActive: null,
                hasPrinterAccess: null,
                permissions: []
            },
            userMode: null,
            userId: null,
            usernameDuplicate: false,
            userPermissions: [...permissions],
            permission: [...permissions],
            searchText: "",
        }
    },
    watch: {
        searchText(value) {
            if (value && value.trim() !== "") {
                this.selectRole = null
                this.userPermissions = this.permission.filter(p =>
                    p.title.includes(value)
                );
            }
            else {
                this.userPermissions = [...this.permission];
            }
        },
        selectRole(value) {
            if (value == null) {
                this.userPermissions = this.permission
            }
            if (value == 1) {
                this.userPermissions = this.permission
            }
            if (value == 2) {
                this.userPermissions = [
                    {
                        key: "online_orders_view",
                        title: "نمایش لیست سفارشات آنلاین"
                    },
                    {
                        key: "comprehensive_orders_view",
                        title: "نمایش لیست جامع سفارشات"
                    },
                    {
                        key: "order_details_view",
                        title: "نمایش جزئیات سفارش"
                    },
                    {
                        key: "sms_charges_report",
                        title: "گزارش شارژ حساب پیامکی"
                    },
                    {
                        key: "sent_sms_report",
                        title: "گزارش ارسال پیامک"
                    },
                    {
                        key: "stock_movements_view",
                        title: "نمایش لیست ورود و خروج انبار"
                    },
                ]
            }
            if (value == 3) {
                this.userPermissions = [
                    {
                        key: "daily_orders_view",
                        title: "نمایش لیست سفارشات روزانه"
                    },
                    {
                        key: "cashier_orders_view",
                        title: "نمایش لیست سفارشات صندوقدار"
                    },
                    {
                        key: "online_orders_view",
                        title: "نمایش لیست سفارشات آنلاین"
                    },
                    {
                        key: "order_details_view",
                        title: "نمایش جزئیات سفارش"
                    },
                    {
                        key: "preparation_status_change",
                        title: "تغییر وضعیت آماده سازی"
                    },
                    {
                        key: "manual_order_print",
                        title: "پرینت دستی سفارش"
                    },
                    {
                        key: "auto_order_print",
                        title: "پرینت خودکار سفارش"
                    },
                    {
                        key: "preorder_create",
                        title: "ثبت پیش‌سفارش"
                    },
                    {
                        key: "preorder_edit",
                        title: "ویرایش پیش‌سفارش"
                    },
                    {
                        key: "order_create",
                        title: "ثبت سفارش"
                    },
                    {
                        key: "order_return",
                        title: "ثبت مرجوعی سفارش"
                    },
                    {
                        key: "hall_requests",
                        title: "درخواست‌های سالن‌دار"
                    },
                    {
                        key: "customers_view",
                        title: "نمایش لیست مشتریان"
                    },
                    {
                        key: "customer_details_view",
                        title: "نمایش جزئیات مشتری"
                    },
                    {
                        key: "customer_create",
                        title: "ایجاد مشتری"
                    },
                    {
                        key: "customer_edit",
                        title: "ویرایش مشتری"
                    },
                    {
                        key: "customer_orders_view",
                        title: "نمایش لیست سفارشات مشتری"
                    },
                    {
                        key: "sent_sms_report",
                        title: "گزارش ارسال پیامک"
                    },
                    {
                        key: "categories_products_view",
                        title: "نمایش لیست دسته‌بندی و محصولات"
                    },
                    {
                        key: "products_availability_status_change",
                        title: "تغییر وضعیت موجودی محصولات"
                    }
                ]
            }
            if (value == 4) {
                this.userPermissions = [
                    {
                        key: "daily_orders_view",
                        title: "نمایش لیست سفارشات روزانه"
                    },
                    {
                        key: "order_details_view",
                        title: "نمایش جزئیات سفارش"
                    },
                    {
                        key: "preparation_status_change",
                        title: "تغییر وضعیت آماده سازی"
                    },
                    {
                        key: "manual_order_print",
                        title: "پرینت دستی سفارش"
                    },
                    {
                        key: "preorder_create",
                        title: "ثبت پیش‌سفارش"
                    },
                    {
                        key: "preorder_edit",
                        title: "ویرایش پیش‌سفارش"
                    },
                    {
                        key: "hall_requests",
                        title: "درخواست‌های سالن‌دار"
                    },
                    {
                        key: "customers_view",
                        title: "نمایش لیست مشتریان"
                    },
                    {
                        key: "customer_details_view",
                        title: "نمایش جزئیات مشتری"
                    },
                    {
                        key: "customer_create",
                        title: "ایجاد مشتری"
                    },

                ]
            }
            if (value == 5) {
                this.userPermissions = [
                    {
                        key: "daily_orders_view",
                        title: "نمایش لیست سفارشات روزانه"
                    },
                    {
                        key: "order_details_view",
                        title: "نمایش جزئیات سفارش"
                    },
                    {
                        key: "preparation_status_change",
                        title: "تغییر وضعیت آماده سازی"
                    },
                    {
                        key: "manual_order_print",
                        title: "پرینت دستی سفارش"
                    },
                    {
                        key: "categories_products_view",
                        title: "نمایش لیست دسته‌بندی و محصولات"
                    },
                    {
                        key: "products_availability_status_change",
                        title: "تغییر وضعیت موجودی محصولات"
                    }
                ]
            }
            if (value == 6) {
                this.userPermissions = [
                    {
                        key: "order_details_view",
                        title: "نمایش جزئیات سفارش"
                    },
                    {
                        key: "campaigns_report",
                        title: "گزارش کمپین‌های هوشمند"
                    },
                    {
                        key: "manage_campaigns",
                        title: "ایجاد، ویرایش و تغییر وضعیت کمپین‌های هوشمند"
                    },
                    {
                        key: "customers_view",
                        title: "نمایش لیست مشتریان"
                    },
                    {
                        key: "customer_details_view",
                        title: "نمایش جزئیات مشتری"
                    },
                    {
                        key: "customer_create",
                        title: "ایجاد مشتری"
                    },
                    {
                        key: "customers_bulk_create",
                        title: "ایجاد گروهی مشتری"
                    },
                    {
                        key: "customer_edit",
                        title: "ویرایش مشتری"
                    },
                    {
                        key: "customer_orders_view",
                        title: "نمایش لیست سفارشات مشتری"
                    },
                    {
                        key: "loyalty_settings",
                        title: "تنظیمات باشگاه مشتریان"
                    },
                    {
                        key: "manage_customer_comments",
                        title: "گزارش و مدیریت نظرات مشتریان"
                    },
                    {
                        key: "customer_comments_settings",
                        title: "تنظیمات نظرات مشتریان"
                    },
                    {
                        key: "customer_level_increase",
                        title: "افزایش سطح مشتری"
                    },
                    {
                        key: "loyalty_changes_report",
                        title: "گزارش تغییر سطوح و امتیازات مشتریان"
                    },
                    {
                        key: "adjust_customer_wallet",
                        title: "افزایش اعتبار مشتری"
                    },
                    {
                        key: "customer_wallet_changes_report",
                        title: "گزارش تغییر اعتبار و کیف پول مشتریان"
                    },
                    {
                        key: "send_bulk_sms",
                        title: "ارسال گروهی پیامک"
                    },
                    {
                        key: "sent_sms_report",
                        title: "گزارش ارسال پیامک"
                    },
                    {
                        key: "sms_settings",
                        title: "الگوهای پیامک سیستمی"
                    },
                ]
            }
            if (value == 7) {
                this.userPermissions = [
                    {
                        key: "categories_products_create",
                        title: "ایجاد دسته‌بندی و محصولات"
                    },
                    {
                        key: "categories_products_edit",
                        title: "ویرایش دسته‌بندی و محصولات"
                    },
                    {
                        key: "categories_products_delete",
                        title: "حذف دسته‌بندی و محصولات"
                    },
                    {
                        key: "categories_products_view",
                        title: "نمایش لیست دسته‌بندی و محصولات"
                    },
                    {
                        key: "categories_products_status_change",
                        title: "تغییر وضعیت و نمایش دسته‌بندی و محصولات"
                    },
                    {
                        key: "products_availability_status_change",
                        title: "تغییر وضعیت موجودی محصولات"
                    },
                    {
                        key: "update_products_batch",
                        title: "ویرایش گروهی محصولات"
                    },
                    {
                        key: "warehouse_categories_materials_create",
                        title: "ایجاد دسته‌بندی و مواد اولیه (کالا)"
                    },
                    {
                        key: "warehouse_categories_materials_edit",
                        title: "ویرایش دسته‌بندی و مواد اولیه (کالا)"
                    },
                    {
                        key: "warehouse_people_manage",
                        title: "ایجاد و ویرایش اشخاص"
                    },
                    {
                        key: "warehouses_manage",
                        title: "ایجاد و ویرایش انبار"
                    },
                    {
                        key: "warehouse_invoices_view",
                        title: "نمایش لیست و جزئیات فاکتور انبار"
                    },
                    {
                        key: "warehouse_invoices_create",
                        title: "ثبت فاکتور انبار"
                    },
                    {
                        key: "stock_takings_view",
                        title: "نمایش لیست و جزئیات انبارگردانی"
                    },
                    {
                        key: "stock_takings_create",
                        title: "ثبت گزارش انبارگردانی"
                    },
                    {
                        key: "stock_takings_edit_delete",
                        title: "ویرایش و حذف گزارش انبارگردانی"
                    },
                    {
                        key: "stock_takings_approve",
                        title: "تایید گزارش انبارگردانی"
                    },
                    {
                        key: "stock_movements_view",
                        title: "نمایش لیست ورود و خروج انبار"
                    }
                ]
            }
            if (value == 8) {
                this.userPermissions = [
                    {
                        key: "warehouse_invoices_view",
                        title: "نمایش لیست و جزئیات فاکتور انبار"
                    },
                    {
                        key: "warehouse_invoices_create",
                        title: "ثبت فاکتور انبار"
                    },
                    {
                        key: "stock_takings_view",
                        title: "نمایش لیست و جزئیات انبارگردانی"
                    },
                    {
                        key: "stock_takings_create",
                        title: "ثبت گزارش انبارگردانی"
                    },
                    {
                        key: "stock_takings_edit_delete",
                        title: "ویرایش و حذف گزارش انبارگردانی"
                    }
                ]
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        selectAllDisplayed() {
            this.form.permissions = [
                ...new Set([...this.form.permissions, ...this.userPermissions.map(item => item.key)])
            ];
        },
        clearAll() {
            this.form.permissions = [];
            this.searchText = ""
            this.selectRole = null
            this.userPermissions = this.permission
        },
        change() {
            this.usernameDuplicate = false
            this.form.username = `${this.form.username}-${this.storeId}`
        },
        showModalDelete(item) {
            this.userId = item.id
            this.form.firstName = item.firstName
            this.form.lastName = item.lastName
            this.$bvModal.show('delete-user')
        },
        managementUser() {
            if (this.userMode == 'ایجاد') {
                this.createUser()
            }
            if (this.userMode == 'ویرایش') {
                this.editUser()
            }
        },
        showModalEdit(item, index) {
            this.$set(this.loadingsButton, index, true);
            this.userId = item.id
            this.userMode = 'ویرایش'
            this.usernameDuplicate = false
            this.selectRole = null
            this.searchText = ""
            storeService.getUser(this.storeId, this.userId).then(({ data }) => {
                this.form.username = data.username
                this.form.password = null
                this.form.firstName = data.firstName
                this.form.description = data.description
                this.form.collaborationEndDate = data.collaborationEndDate
                this.form.isAccountActive = data.isAccountActive
                this.form.hasPrinterAccess = data.hasPrinterAccess
                const dataPermissions = data.permissions
                this.form.permissions = dataPermissions
                    .filter(item => item.hasAccess)
                    .map(item => item.key);
                this.form.lastName = data.lastName
                this.$bvModal.show('management-user')
            })
                .finally(() => {
                    this.$set(this.loadingsButton, index, false);
                });
        },
        showModalCreateUser() {
            this.userMode = 'ایجاد'
            this.form.username = null
            this.form.password = null
            this.form.firstName = null
            this.form.description = null
            this.form.collaborationEndDate = null
            this.form.isAccountActive = null
            this.form.hasPrinterAccess = null
            this.form.permissions = []
            this.form.lastName = null
            this.usernameDuplicate = false
            this.selectRole = null
            this.searchText = ""
            this.$bvModal.show('management-user')
        },
        deleteUser() {
            this.loadingButton = true
            storeService.deleteUser(this.storeId, this.userId).then(({ data }) => {
                this.$notif({ type: 'success', title: 'کاربر با موفقیت حذف شد' });
                this.$bvModal.hide('delete-user')
                this.getUsers()
            })
                .finally(() => {
                    this.loadingButton = false
                });
        },
        editUser() {
            this.$refs.managementUserValidation.validate().then((success) => {
                if (success) {
                    let data = {
                        username: this.form.username,
                        firstName: this.form.firstName,
                        lastName: this.form.lastName,
                        newPassword: this.form.password,
                        permissions: this.form.permissions,
                        hasPrinterAccess: this.form.hasPrinterAccess,
                        isAccountActive: this.form.isAccountActive,
                        collaborationEndDate: this.form.collaborationEndDate,
                        description: this.form.description,
                    }
                    if (this.form.permissions.length) {
                        this.loadingButton = true
                        storeService.editUser(this.storeId, this.userId, data).then(({ data }) => {
                            this.$refs.managementUserValidation.reset();
                            this.$notif({ type: 'success', title: 'کاربر با موفقیت ویرایش شد' });
                            this.$bvModal.hide('management-user')
                            this.getUsers()
                        })
                            .catch(({ response }) => {
                                if (response.data.errors[0].code == 'Username_Is_Duplicate') {
                                    this.usernameDuplicate = true
                                }
                                else {
                                    this.usernameDuplicate = false
                                }
                            })
                            .finally(() => {
                                this.loadingButton = false
                            });
                    }
                    else {
                        this.$notif({ type: 'normal', title: `برای ${this.userMode} کاربر حداقل یک دسترسی اضافه کنید` });
                    }
                }
            });
        },
        createUser() {
            this.$refs.managementUserValidation.validate().then((success) => {
                if (success) {
                    if (this.form.permissions.length) {
                        this.loadingButton = true
                        storeService.createUser(this.storeId, this.form).then(({ data }) => {
                            this.$refs.managementUserValidation.reset();
                            this.$notif({ type: 'success', title: 'کاربر با موفقیت ایجاد شد' });
                            this.$bvModal.hide('management-user')
                            this.getUsers()
                        })
                            .catch(({ response }) => {
                                if (response.data.errors[0].code == 'Username_Is_Duplicate') {
                                    this.usernameDuplicate = true
                                }
                                else {
                                    this.usernameDuplicate = false
                                }
                            })
                            .finally(() => {
                                this.loadingButton = false
                            });
                    }
                    else {
                        this.$notif({ type: 'normal', title: `برای ${this.userMode} کاربر حداقل یک دسترسی اضافه کنید` });
                    }
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getUsers();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getUsers() {
            this.loading = true
            storeService.getUsers(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.usersList = data.items
                    if (this.usersList.length) {
                        this.usersList.forEach(obj => {
                            this.loadingsButton.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.usersList = data.items
                        if (this.usersList.length) {
                            this.usersList.forEach(obj => {
                                this.loadingsButton.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.permissions-container {
    height: 186px;
    overflow-y: auto;
}
</style>